import React, { useState } from 'react'
import { useResume } from '../ResumeProvider'
import { EditableHeading, newKey } from './common'
import { Button } from '../../../lib/ui/button'
import { PlusIcon } from '@heroicons/react/24/outline'
import SkillsItem from './SkillsItem'
import { EditorItemProvider } from './EditorItemProvider'
import { useTranslation } from '~/hooks/useTranslation'

const SkillsEditor = () => {
  const { t } = useTranslation('SkillsEditor')
  const { resumeDocument, setResumeDocument } = useResume()
  const skills = resumeDocument.skills || []
  const [activeIndex, setActiveIndex] = useState(-1)

  const addSkill = () => {
    const updatedSkills = [...skills, {}]
    setActiveIndex(updatedSkills.length - 1)
    setResumeDocument({ ...resumeDocument, skills: updatedSkills })
  }

  return (
    <div className="flex flex-col">
      <div className="mb-4 flex flex-row">
        <EditableHeading
          title={t('skills')}
          description={t('change_skills_heading')}
          settingName="skillsHeading"
        />
      </div>
      <div className="pb-4 tracking-[0.024px]">
        {t('select_skills_description')}
      </div>
      {skills.map((skill, skillIndex) => {
        skill.key = skill.key || newKey()
        return (
          <div key={skill.key}>
            <EditorItemProvider
              sectionName="skills"
              index={skillIndex}
              activeIndex={activeIndex}
              setActiveIndex={setActiveIndex}
              item={skill}
            >
              <SkillsItem />
            </EditorItemProvider>
          </div>
        )
      })}
      <Button onClick={addSkill} className="mt-4 max-w-min">
        {t('add_skill')}
        <PlusIcon className="ml-2 w-5" />
      </Button>
    </div>
  )
}
export default SkillsEditor
